<onsip-header-main>
  <onsip-header-page-title>{{
    "ONSIP_I18N.TEAM_PAGE_CONFIGURATION" | translate | sentenceCase
  }}</onsip-header-page-title>
  @if ((isSmall | async) === false) {
  <onsip-header-action-bar>
    <a mat-stroked-button color="primary" [href]="'https://' + teamPageDomain" target="_blank">
      <mat-icon>forward</mat-icon>
      {{ "ONSIP_I18N.SEE_CHANGES_LIVE" | translate }}
    </a>
  </onsip-header-action-bar>
  }
</onsip-header-main>
<div class="config">
  <!-- Accent Color Picker -->
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.ACCENT_COLOR" | translate }}</mat-card-title>
    <mat-card-content>
      @if (organizationId) {
      <onsip-teampage-color-picker
        (colorChange)="onColorChange($event)"
      ></onsip-teampage-color-picker>
      }
    </mat-card-content>
  </mat-card>
  <!-- Logo Picker-->
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.LOGO" | translate }}</mat-card-title>
    <mat-card-content>
      <div class="logo-picker">
        @if (logo) {
        <div
          class="org-logo"
          [style.background-color]="color | async"
          [style.color]="color | async | textColorForCustomBackground"
          [style.border-color]="color | async"
        >
          <img [src]="logo || ''" alt="Organization Logo" />
        </div>
        } @if (!logo) {
        <div
          class="org-logo"
          [style.background-color]="color | async"
          [style.color]="color | async | textColorForCustomBackground"
          [style.border-color]="color | async"
        >
          {{ "ONSIP_I18N.NO_LOGO_SELECTED" | translate }}
        </div>
        }
        <button
          id="onsip--organization--open-upload-logo-modal"
          aria-label="edit logo"
          mat-button
          color="primary"
          class="edit-button team-settings-btn"
          (click)="openUploadLogoModal()"
        >
          {{ "ONSIP_I18N.CHANGE_LOGO" | translate }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
  <!-- Greetings -->
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.GREETING" | translate }}</mat-card-title>
    <mat-card-content>
      <mat-form-field
        class="onsip-outlined-form form-field"
        appearance="outline"
        (change)="submit()"
      >
        <textarea
          matInput
          cdkTextareaAutosize
          type="text"
          [(ngModel)]="greeting"
          [placeholder]="setGreetingTranslation"
          [maxlength]="maxGreetingLength"
        ></textarea>
        <mat-hint align="end"
          >{{ greeting.length || 0 }}/75 {{ "ONSIP_I18N.CHARACTERS" | translate }}</mat-hint
        >
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <!-- Bio-->
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.BIO" | translate }}</mat-card-title>
    <mat-card-content>
      <mat-form-field class="onsip-outlined-form form-field" appearance="outline">
        <textarea
          matInput
          cdkTextareaAutosize
          type="text"
          [(ngModel)]="blurb"
          (change)="submit()"
          [placeholder]="setBioTranslation"
          [maxlength]="maxBlurbLength"
        ></textarea>
        <mat-hint align="end"
          >{{ blurb.length || 0 }}/500 {{ "ONSIP_I18N.CHARACTERS" | translate }}</mat-hint
        >
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <!-- Team Members -->
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.TEAM_MEMBERS" | translate }}</mat-card-title>
    <mat-card-content>
      <onsip-team-member-form></onsip-team-member-form>
    </mat-card-content>
  </mat-card>
  <!-- Team Page Url -->
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.YOUR_TEAM_PAGE_URL" | translate }}</mat-card-title>
    <mat-card-content>
      <a class="team-settings-btn" href="https://{{ teamPageDomain }}" target="_blank">
        https://{{ teamPageDomain }}
      </a>
    </mat-card-content>
  </mat-card>
</div>
<onsip-team-settings-preview></onsip-team-settings-preview>
